import React, { useEffect, useState } from "react";
import { Identification } from "../../Identification";
import { SOMMAIRE_RISQUE_LIBELLE } from "../../../../utilities/Utilities";
import swal from "sweetalert";
import Swal from "sweetalert2";
import {
  ajouterRisqueEvaluation,
  getDetailsRisqueEvaluationActivite,
  getDetailsRisqueEvaluationFraude,
  getDetailsRisqueEvaluationInformatique,
  supprimerAllRisqueEvaluation,
} from "../../../../../data/risqueEvaluation";
import { TraitementEvaluation } from "./evaluation/TraitementEvaluation";
import { getListeIdentificationSommaire } from "../../../../../data/rateau";
import {
  faFileImport,
  faIdCard,
  faSave,
  faTasks,
} from "@fortawesome/free-solid-svg-icons";
import PageToolbarHeader from "../../../../modals/PageToolbarHeader";
import { StepBody, StepHeader } from "../../../../common/Step.components";
import ModalNavBarMenu from "../../../../modals/ModalNavBarMenu";
import { Button, notification, Tooltip } from "antd";
import { appTheme } from "../../../../../config/theme";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import UserCycleIdentification from "../../UserCycleIdentification";
import { useNavigate } from "react-router-dom";
import { verifierExercicePrecedent } from "../../../../../data/exercice";

const RisqueEvaluation = ({ mission, client, code, modalId, prev }) => {
  const [activeTab, setActiveTab] = useState(0);
  const [loading, setLoading] = useState(false);
  const [tache_id, setTache_id] = useState(null);
  const [user_id, setUser_id] = useState(null);
  const [date, setDate] = useState("");
  const [heureEntree, setHeureEntree] = useState("");
  const [intervention_id, setIntervention_id] = useState(null);
  const [identifications, setIdentifications] = useState([]);
  const [codeSommaire] = useState(code || "");
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [selectYear, setSelectYear] = useState(mission.annee || "");
  const [missionSelected, setMissionSelected] = useState(mission || null);
  const [isProvisoire, setIsProvisoire] = useState("1");
  const [normeCode, setNormeCode] = useState("");
  const [selecteData, setSelectData] = useState([]);
  const [isAddMemoire, setIsAddMemoire] = useState("");
  const [libelle, setLibelle] = useState("");
  const [datas, setDatas] = useState([]);
  const [title, setTitle] = useState("");
  const [isTaskSave, setIsTaskSave] = useState([]);
  const [auth, setAuth] = useState(false);
  const [exercicePrecedentData, setExercicePrecedentData] = useState(null);

  // Fonction pour vérifier si aucune évaluation n'a été faite
  // Retourne true si AUCUNE probabilité et AUCUN impact n'ont été renseignés
  const hasNoEvaluationData = () => {
    if (!selecteData || selecteData.length === 0) return true;

    // Vérifie si TOUTES les assertions n'ont PAS de probabilité ET PAS d'impact
    const allEmpty = selecteData.every((rubrique) =>
      rubrique.risquesDetails?.every((event) =>
        event.risqueIncidences?.every((incidence) =>
          incidence.risquesAssertions?.every(
            (assertion) => !assertion.probabilite_id && !assertion.impact_id
          )
        )
      )
    );

    return allEmpty;
  };

  const navigate = useNavigate();

  const fetchEvaluationActivite = async (mission_id) => {
    getDetailsRisqueEvaluationActivite(mission_id)
      .then((res) => {
        setDatas(res.result);
      })
      .catch((error) => {
        notification.error({
          description: error,
        });
      });
  };

  const fetchEvaluationfraude = async (mission_id) => {
    getDetailsRisqueEvaluationFraude(mission_id)
      .then((res) => {
        setDatas(res.result);
      })
      .catch((error) => {
        notification.error({
          description: error,
        });
      });
  };

  const fetchEvaluationInformatique = async (mission_id) => {
    getDetailsRisqueEvaluationInformatique(mission_id)
      .then((res) => {
        setDatas(res.result);
      })
      .catch((error) => {
        notification.error({
          description: error,
        });
      });
  };

  useEffect(() => {
    setNormeCode(`ED${modalId}`);
    if (modalId === 1) {
      fetchEvaluationActivite(missionSelected.id);
      setTitle("ED1.2 - Evaluation risques liés à l'activité");
      setLibelle(SOMMAIRE_RISQUE_LIBELLE.ACTIVITE);
    } else if (modalId === 2) {
      fetchEvaluationfraude(missionSelected.id);
      setTitle("ED2.2 - Evaluation risques liés à la fraude et aux erreurs");
      setLibelle(SOMMAIRE_RISQUE_LIBELLE.FRAUDE);
    } else if (modalId === 3) {
      fetchEvaluationInformatique(missionSelected.id);
      setTitle("ED3.2 - Evaluation risques liés à l'informatique");
      setLibelle(SOMMAIRE_RISQUE_LIBELLE.INFORMATIQUE);
    }
  }, [missionSelected, modalId]);

  useEffect(() => {
    if (activeTab === 0) {
      getListeIdentificationSommaire(missionSelected.id, codeSommaire).then(
        (res) => {
          setIdentifications(res.result);
        }
      );
    }
  }, [activeTab, missionSelected, codeSommaire]);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (auth || (isTaskSave ?? []).length > 0) {
        e.preventDefault();
        e.returnValue = "";
        return true;
      }
      return null;
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [auth, isTaskSave, navigate]);

  // Récupération de l'exercice précédent
  const fetchExercicePrecedent = async () => {
    await verifierExercicePrecedent(missionSelected.id)
      .then((res) => {
        if (res?.status === "success" && res?.result) {
          setExercicePrecedentData(res.result);
        } else {
          setExercicePrecedentData(null);
        }
      })
      .catch((err) => {
        console.error("Erreur lors de la vérification:", err);
      });
  };

  useEffect(() => {
    if (missionSelected?.id) {
      fetchExercicePrecedent();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [missionSelected?.id]);

  // Fonction pour récupérer les données de l'exercice précédent selon le type
  const fetchExercicePrecedentData = async (exerciceId) => {
    let res;
    if (modalId === 1) {
      res = await getDetailsRisqueEvaluationActivite(exerciceId);
    } else if (modalId === 2) {
      res = await getDetailsRisqueEvaluationFraude(exerciceId);
    } else if (modalId === 3) {
      res = await getDetailsRisqueEvaluationInformatique(exerciceId);
    }
    return res;
  };

  // Fonction d'importation des données de l'exercice précédent
  const handleImport = async () => {
    const result = await Swal.fire({
      title: '<strong style="font-size: 1.5em;">Êtes vous sûr ?</strong>',
      html: "Voulez-vous importer les évaluations (Probabilité et Impact) de l'exercice précédent ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d1ec51",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui",
      cancelButtonText: "Annuler",
    });

    if (!result.isConfirmed) return;

    setLoading(true);
    try {
      const res = await fetchExercicePrecedentData(exercicePrecedentData.id);

      if (res?.result && res.result.length > 0) {
        const exercicePrecedent = res.result;

        // Créer un map des évaluations de l'exercice précédent par eventRisque_id et incidence
        const evaluationsMap = new Map();

        exercicePrecedent.forEach((item) => {
          item.Lea_RisqueIdentificationDetails?.forEach((detail) => {
            detail.Lea_RisqueEvaluations?.forEach((evaluation, index) => {
              // Clé unique basée sur eventRisque_id + incidence + index
              const key = `${item.eventRisque_id}_${detail.incidence}_${index}`;
              evaluationsMap.set(key, {
                probabilite_id: evaluation.probabilite_id,
                probabiliteValue: evaluation.probabiliteValue,
                impact_id: evaluation.impact_id,
                impactValue: evaluation.impactValue,
                score: evaluation.score,
                niveau_id: evaluation.niveau_id,
              });
            });
          });
        });

        // Appliquer les évaluations aux données existantes
        const updatedDatas = datas.map((item) => ({
          ...item,
          Lea_RisqueIdentificationDetails:
            item.Lea_RisqueIdentificationDetails?.map((detail) => ({
              ...detail,
              Lea_RisqueEvaluations:
                detail.Lea_RisqueIdentificationAssertions?.map(
                  (assertion, index) => {
                    const key = `${item.eventRisque_id}_${detail.incidence}_${index}`;
                    const existingEvaluation = evaluationsMap.get(key);

                    if (existingEvaluation) {
                      return {
                        ...existingEvaluation,
                        // Garder l'ID null pour créer une nouvelle évaluation
                        id: null,
                      };
                    }

                    // Si pas d'évaluation correspondante, retourner vide
                    return detail.Lea_RisqueEvaluations?.[index] || {};
                  }
                ) || [],
            })),
        }));

        // Mettre à jour les données
        setDatas(updatedDatas);

        await swal({
          title: "Importation effectuée avec succès",
          text: "Les évaluations (Probabilité et Impact) ont été importées. Pensez à enregistrer les modifications.",
          icon: "success",
        });
      } else {
        await swal(
          "Aucune donnée d'évaluation trouvée pour l'exercice précédent.",
          "",
          "error"
        );
      }
    } catch (error) {
      console.error("Erreur lors de l'importation:", error);
      await swal("Erreur lors de l'importation", "", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteAllEvaluation = () => {
    setLoading(true);

    const risqueIncidences = [];
    selecteData.forEach((select) => {
      select.risquesDetails.forEach((risque) => {
        risque.risqueIncidences.forEach((item) => {
          risqueIncidences.push({ incidence_id: item.incidence_id });
        });
      });
    });

    const data = {
      intervention_id,
      date,
      heureEntree,
      tache_id,
      user_id,
      codeSommaire,
      isAddMemoire,
      client: client.id,
      risqueIncidences,
      isProvisoire,
      libelle,
      exercice_id: missionSelected.id,
      client_id: client.id,
    };
    setLoading(false);

    supprimerAllRisqueEvaluation(data)
      .then(async (res) => {
        const { status, message } = res;
        if (status === "success") {
          setLoading(false);

          if (modalId === 1) {
            await fetchEvaluationActivite(missionSelected.id);
          } else if (modalId === 2) {
            await fetchEvaluationfraude(missionSelected.id);
          } else if (modalId === 3) {
            await fetchEvaluationInformatique(missionSelected.id);
          }

          await swal(`Opération effectuée avec succès`, "", "success");
        } else {
          await swal(message, "", "error");
          setLoading(false);
        }
      })
      .catch((err) => {
        notification.error({
          description: err,
        });
      });
  };

  const handleSubmit = async () => {
    setLoading(true);

    try {
      const isRequired = selecteData.some((select) => {
        return select.risquesDetails.some((risque) => {
          return risque.risqueIncidences.some((risqueIncid) => {
            return risqueIncid.risquesAssertions.some((risqueAssert) => {
              return (
                !risqueAssert.probabilite_id ||
                !risqueAssert.niveau_id ||
                !risqueAssert.impact_id
              );
            });
          });
        });
      });

      if (isRequired) {
        notification.error({
          description: "Veuillez renseigner tous les champs obligatoires",
        });
        return;
      }

      const risqueIncidences = [];
      selecteData.forEach((item) => {
        item.risquesDetails.forEach((event) => {
          event.risqueIncidences.forEach((incidence) => {
            risqueIncidences.push(incidence);
          });
        });
      });

      const data = {
        intervention_id,
        date,
        heureEntree,
        tache_id,
        user_id,
        codeSommaire,
        isAddMemoire,
        client: client.id,
        risqueIncidences,
        isProvisoire,
        libelle,
        exercice_id: missionSelected.id,
        client_id: client.id,
      };

      const response = await ajouterRisqueEvaluation(data);

      if (!response) {
        await swal("Erreur", "Aucune réponse du serveur.", "error");
        return;
      }

      const { status, message } = response;

      if (status === "success") {
        setAuth(false);
        await swal(`Opération effectuée avec succès`, "", "success");
      } else {
        await swal(message, "", "error");
      }
    } catch (error) {
      console.error("Erreur lors de l'enregistrement:", error);
      await swal(
        "Erreur",
        "Une erreur inattendue est survenue. Veuillez réessayer.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const formSteps = [
    {
      code: "ID",
      title: "IDENTIFICATIONS",
      icon: faIdCard,
      content: (
        <UserCycleIdentification
          setDate={setDate}
          dateDebut={date}
          setTache_id={setTache_id}
          setIntervention_id={setIntervention_id}
          setHeureEntree={setHeureEntree}
          setUser_id={setUser_id}
          mission={mission}
          prev={prev}
          loading={loading}
          codeSommaire={codeSommaire}
          setIsAuthorized={setAuth}
          isAuthorized={auth}
          setActiveStep={setActiveTab}
        />
      ),
    },
    {
      code: "CB",
      title: `TRAITEMENT - ${selectYear}`,
      description: `TRAITEMENT - ${selectYear}`,
      icon: faTasks,
      content: (
        <TraitementEvaluation
          selecteData={selecteData}
          setSelectData={setSelectData}
          setDatas={setDatas}
          datas={datas}
          setIsAddMemoire={setIsAddMemoire}
          id={modalId}
          mission={missionSelected}
          isProvisoire={isProvisoire}
          libelleRisque={libelle}
          handleDeleteAllEvaluation={handleDeleteAllEvaluation}
        />
      ),
    },
  ];

  return (
    <>
      <div className="mx-5">
        <PageToolbarHeader
          prev={prev}
          codeSommaire={codeSommaire}
          pageTitle={title}
          mission={missionSelected}
          setMission={setMissionSelected}
          isProvisoire={isProvisoire}
          setIsProvisoire={setIsProvisoire}
          selectYear={selectYear}
          setSelectYear={setSelectYear}
          loading={loading}
          setLoading={setLoading}
          client={client}
          setIsModalOpen={setIsModalOpen}
          isModalOpen={isModalOpen}
          setDate={setDate}
          setTache_id={setTache_id}
          tache_id={tache_id}
          setIntervention_id={setIntervention_id}
          intervention_id={intervention_id}
          setHeureEntree={setHeureEntree}
          setUser_id={setUser_id}
        />
        <StepHeader>
          <ModalNavBarMenu
            setActiveTab={setActiveTab}
            activeTab={activeTab}
            steps={formSteps}
            setLoading={setLoading}
            loading={loading}
            isTaskSave={isTaskSave}
            auth={auth}
          />
        </StepHeader>
        <StepBody>
          <>
            {activeTab !== 0 && (
              <div className="d-flex justify-content-end align-items-end mb-10 gap-2">
                {/* Bouton Importer - affiché uniquement si exercice précédent existe ET aucune évaluation n'a été faite */}
                {/* {exercicePrecedentData && hasNoEvaluationData() && (
                  <Tooltip title="Importer les données de l'année précédente">
                    <Button
                      disabled={
                        !!mission.isCloture || !!mission.isClotureProvisoire
                      }
                      loading={loading}
                      size={"large"}
                      style={{
                        backgroundColor: appTheme.colors.primary,
                        color: "white",
                      }}
                      icon={
                        <FontAwesomeIcon
                          style={{ paddingRight: "10" }}
                          icon={faFileImport}
                        />
                      }
                      onClick={handleImport}
                    >
                      {!loading && (
                        <span className="indicator-label text-white">
                          Importer
                        </span>
                      )}
                      {loading && (
                        <span className="indicator-progress text-white">
                          Importation en cours...
                        </span>
                      )}
                    </Button>
                  </Tooltip>
                )} */}

                {/* Bouton Enregistrer */}
                <Tooltip title="Enregistrer">
                  <Button
                    disabled={
                      !!mission.isCloture || !!mission.isClotureProvisoire
                    }
                    size={"large"}
                    loading={loading}
                    style={{
                      backgroundColor: appTheme.colors.secondary,
                      color: "white",
                    }}
                    icon={
                      <FontAwesomeIcon
                        style={{ paddingRight: "10" }}
                        icon={faSave}
                      />
                    }
                    onClick={handleSubmit}
                  >
                    {!loading && (
                      <span className="indicator-label text-white">
                        Enregistrer
                      </span>
                    )}
                    {loading && (
                      <span className="indicator-progress text-white">
                        Patientez svp...
                      </span>
                    )}
                  </Button>
                </Tooltip>
              </div>
            )}
            {formSteps[activeTab].content}
          </>
        </StepBody>
      </div>
    </>
  );
};

export { RisqueEvaluation };
